// This is example of menu item without group for horizontal layout. There will be no children.

// third-party
import { FormattedMessage } from 'react-intl';

// assets
// import { Schoolr } from 'lucide-react';

// type

// icons
// const icons = {
//     learning: School
// };

// ==============================|| MENU ITEMS - SAMPLE PAGE ||============================== //

const favorites =     {
  id: 'favorites',
  title: <FormattedMessage id="favorites" />,
  type: 'group',
  url: '/favorites',
}

export default favorites;
